import * as React from 'react';
import { Box, Typography } from '@mui/material';

interface DashboardMetricCardTitleProps {
  title: string;
  subtitle: string;
}

export const DashboardMetricCardTitle = ({ title, subtitle }: DashboardMetricCardTitleProps) => {
  const minHeight = title || subtitle ? 48 : 0;
  return (
    <Box sx={{ minHeight }}>
      <Typography sx={{ fontWeight: 500 }}>{title}</Typography>

      <Typography variant="caption" color="textSecondary">
        {subtitle}
      </Typography>
    </Box>
  );
};
